var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendarIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 21"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "calendar-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.833.5h20v20h-20z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#calendar-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.833 16.333A4.17 4.17 0 0 0 5 20.5h11.666a4.17 4.17 0 0 0 4.167-4.167v-7.5h-20zM3.333 13c0-.92.748-1.667 1.667-1.667h1.666c.92 0 1.667.748 1.667 1.667v1.667c0 .919-.747 1.666-1.667 1.666H5c-.92 0-1.667-.747-1.667-1.666zm3.334 1.667H5V13h1.666zm14.166-8.334v.834h-20v-.834A4.17 4.17 0 0 1 5 2.167h.833v-.834a.834.834 0 0 1 1.667 0v.834h6.666v-.834a.834.834 0 0 1 1.667 0v.834h.833a4.17 4.17 0 0 1 4.167 4.166"
}))));
export { SvgCalendarIcon as ReactComponent };
export default __webpack_public_path__ + "4cbf90d9a3508d0542762a689785fc2c.svg";